import _ from 'lodash'
import { fromJS, List, Map } from 'immutable'
import * as actionTypes from './actionTypes'
import { processSFAutoTrigger } from './processSFAutoTrigger'
import { processWidgetCustomSFGet } from './processWidgetCustomSFGet'
import { processWidgetCustomSFPush } from './processWidgetCustomSFPush'
import {
  addItemToOfflineList,
  removeItemToOfflineList,
  setProcessingQueryStatus,
  updateItemInOfflineListComplete,
  updateItemInOfflineListError,
} from './actions'
import { getParams, getState } from '../../lib/processPortalRules'

export const processSFActionQuery = (index, isPortal, query) => async (dispatch, getStoreState) => {
  let state = getStoreState()
  let allowOffline = state.getIn(['project', 'Settings', 'allowOffline'], false)
  if (!query) {
    query = state.getIn(['query', 'list'], List())
  }

  if (query.get(index, false) && !query.getIn([index, 'isProcessing'], false)) {
    let elemUID = query.getIn([index, 'elemUID'])
    dispatch(setProcessingQueryStatus(index))
    let currentState = getStoreState()
    if (!currentState.getIn(['denideActionElements', elemUID])) {
      if (query.getIn([index, 'isPush'])) {
        let { status, error } = await dispatch(processWidgetCustomSFPush(getStoreState(), query.get(index).toJS()))
        if (!status && allowOffline) {
          query = query
            .setIn([index, 'appState'], fromJS(_.assign({}, getParams(state), getState(state))))
            .setIn([index, 'runStatus'], error)
          if (!query.getIn([index, 'runID'])) {
            dispatch(addItemToOfflineList(query))
          } else if (query.getIn([index, 'runID'])) {
            dispatch(updateItemInOfflineListError(query.getIn([index, 'runID']), error))
          }
        } else if (allowOffline && !error && query.getIn([index, 'runID'])) {
          dispatch(updateItemInOfflineListComplete(query.getIn([index, 'runID'])))
          setTimeout(() => {
            dispatch(removeItemToOfflineList(query.getIn([index, 'runID'])))
          }, 300)
        }
      } else {
        await dispatch(processWidgetCustomSFGet(getStoreState(), query.get(index).toJS()))
      }
      await dispatch(processSFAutoTrigger())
    }
  }

  if (query.get(index + 1, false)) {
    await dispatch(processSFActionQuery(index + 1, isPortal, query))
  } else {
    let processedRules = {}
    query.map(function (row) {
      if (row.get('processList')) {
        row.get('processList', List()).map((procID) => {
          processedRules[procID] = true
        })
      }
      if (row.get('processUID')) {
        processedRules[row.get('processUID')] = true
      }
    })
    let currentState = getStoreState()
    if (!currentState.getIn(['sfActions', 'needCall']) && currentState.getIn(['__cond__cache__', 'list'])) {
      currentState.getIn(['__cond__cache__', 'list']).map((row, key) => {
        processedRules[key] = true
      })
    }
    dispatch({
      type: actionTypes.CLEAR_SF_ACTIONS_QUERY,
      payload: {
        values: _.map(query.toJS(), (row) => row.value),
        processedRules,
      },
    })
  }
}
